import { ensureRouteData } from '@/app/query-client'
import { marketNewsService } from '@/features/news/api/marketNewsService'
import { newsArticleQueryOptions } from '@/features/news/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import { newsArticleSearchSchema } from '@/screens/market/news-search'

/** The `/market/news/article` loader: nothing until mm-be serves news, then the story. */
export async function loadNewsArticle({
  context: { queryClient },
  location,
}: {
  context: RouterContext
  location: { search: unknown }
}): Promise<void> {
  if (!marketNewsService.available) return
  const { id, lang } = newsArticleSearchSchema.parse(location.search)
  await ensureRouteData(queryClient, newsArticleQueryOptions(id, lang))
}
